import { Box, Button, Grid, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";
import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Stack from "@mui/material/Stack";
import AppConstants from "../common/AppConstants";
import { AppDataContext } from '../common/AppContext';
import {
    UserProfileConsumer,
    UserProfileContext,
    UserProfileProvider
} from "../common/ProfileContext";
import SimilarProfilesList from "../sharedComponents/SimilarProfilesList/SimilarProfilesList";
import { darkenColor } from "../utils/appHelper";
import clsx from "clsx";
import FeatureArticleNewsContent from "../sharedComponents/FeatureArticleNewsContent/FeatureArticleNewsContent";
import CoachProfileSummary from "../sharedComponents/CoachProfileSummary/CoachProfileSummary";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        backgroundColor: theme.palette.mode === 'dark' ? darkenColor(theme.palette.background.default, 40) : undefined,
    },
    grid: {
        display: "flex",
        flexGrow: 1,
        flexWrap: "wrap",
        paddingTop: theme.spacing(1),
        [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(1),
        },
        [theme.breakpoints.down("xs")]: {
            padding: 0,
            flexGrow: 0,
        },
    },
    section: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
        textAlign: "left",
        padding: "5px 25px",
    },
    gridItem: {
        [theme.breakpoints.up("sm")]: {
            padding: theme.spacing(1),
        },
        [theme.breakpoints.down("xs")]: {
            width: "100%",
            paddingBottom: theme.spacing(2),
        },
    },
    profileSummary: {
        paddingBottom: theme.spacing(2),
        minHeight: "300px",
        boxShadow: '0px 0px 5px rgba(6, 37, 91, .2)',
        borderRadius: '0',
        backgroundColor: theme.palette.mode === 'dark' ? darkenColor(theme.palette.background.default, 25) : theme.palette.primary.dark
    },
    profileDetails: {
        textAlign: "left",
        color: theme.palette.text.secondary,
        borderRadius: '0',
    },
    submitButton: {
        alignContent: "center",
        textAlign: "center",
        paddingBottom: 10,
        paddingRight: 10,
    },
}));

const CoachesProfileLayout = ({ children }) => {
    let isViewMode = false;
    const location = useLocation();
    
    const {
        mobileView
    } = useContext(AppDataContext);

    const getIsViewMode = () => {
        if (location.pathname == "/view") {
            isViewMode = true;
        }
    }

    getIsViewMode();
    const classes = useStyles();
    return (
        <UserProfileProvider>
            <UserProfileConsumer>
                {(props) => {
                    return (
                        <div className={classes.root}>
                            <Grid container className={classes.grid}>
                                {!mobileView &&
                                    <Grid size={{ sm: 2.5, md: 2.5 }} className={classes.gridItem}>
                                        <CoachProfileSummary isViewMode={isViewMode} />
                                    </Grid>

                                }

                                <Grid size={{ md: mobileView ? 12 : (isViewMode ? 7 : 9.5), sm: mobileView ? 12 : (isViewMode ? 7 : 9.5) }} className={classes.gridItem}>
                                    <Paper className={clsx(classes.profileDetails, "custom-view")}>
                                        {children}
                                    </Paper>

                                </Grid>

                                {!mobileView && isViewMode &&
                                    <Grid size={{ md: mobileView ? 12 : 2.5, sm: mobileView ? 12 : 2.5 }} className={classes.gridItem}>
                                        <SidebarContent fullName={props && props.fullName} userName={props && props.userName} />
                                    </Grid>
                                }
                            </Grid>
                        </div>)
                }}
            </UserProfileConsumer>
        </UserProfileProvider>
    );
}

const SidebarContent = ({ fullName = "", userName = "" }) => {
    const classes = useStyles();

    return (
        <>
            <Paper
                className={clsx(classes.profileDetails, "custom-view")}
                sx={{
                    minHeight: '300px',
                    overflow: 'hidden',
                }}
            >
                <Box
                    sx={{
                        backgroundColor: (theme) => theme.palette.mode === 'dark' ? "rgba(255,255,255,0.01)" : theme.palette.primary.main,
                        color: '#ffffff',
                        px: 2,
                        height: 72,
                        display: 'flex',
                        alignItems: 'center',
                        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
                    }}
                >
                    <Typography variant="subtitle2">Similar Profiles</Typography>
                </Box>
                <Box sx={{ p: 1 }}>
                    <SimilarProfilesList userName={userName} />
                </Box>
            </Paper>

            <FeatureArticleNewsContent fullName={fullName} />
        </>
    );
};

export default CoachesProfileLayout;